import {createApp} from 'vue'
import store from 'store'

const el = '[data-content=ClosedGroupOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ClosedGroupOverlayDOM)=>{
            const groupId = ClosedGroupOverlayDOM.dataset.groupId
            store.commit('main/set_page_overlay_content_data', { groupId })
        })
    }
}